import { Skeleton, TableCell, TableRow } from '@folio/components';

// https://stackoverflow.com/questions/398734/colspan-all-columns
const RANDOM_BIG_NUMBER_THAT_SHOULD_BE_BIGGER_THAN_TABLE_COLUMNS = 42;

export function LoadingRow() {
  return (
    <TableRow>
      <TableCell colSpan={RANDOM_BIG_NUMBER_THAT_SHOULD_BE_BIGGER_THAN_TABLE_COLUMNS}>
        <Skeleton className="h-6 w-full" />
      </TableCell>
    </TableRow>
  );
}
